import { toast } from 'sonner'

export type DatabricksProvisionWarnings = {
  warnings?: string[] | null
}

export function showDatabricksProvisionWarnings(data: DatabricksProvisionWarnings) {
  for (const w of data.warnings ?? []) {
    const message = w?.trim()
    if (message) {
      toast.warning(message, { duration: Infinity })
    }
  }
}
